import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  employeeCalendarOnLoad,
  employeeWorkScheduleOverridesOnUnload,
} from "features/planner/employee/employee.actions";

import { EMPTY_LIST, EMPTY_MAP } from "app/app.constants";
import { getCardWorkDays } from "features/planner/planner.actions";
import CalendarYear from "app/components/CalendarYear/CalendarYear";
import CalendarWorkDay from "features/planner/employee/components/CalendarWorkDay";
import { getDeploymentDetailsByCardIdFromState } from "features/planner/planner.selectors";
import AvailabilityOverrides from "features/planner/employee/calendar/components/AvailabilityOverride";

class EmployeeCalendar extends PureComponent {
  componentDidMount() {
    const { employeeCardId, dispatchOnLoad } = this.props;
    dispatchOnLoad(employeeCardId);
  }

  componentWillUnmount() {
    const { dispatchOnUnload } = this.props;
    dispatchOnUnload();
  }

  getCardWorkDays = (startDate, endDate) => {
    const { employeeCardId, dispatchGetCardWorkDays } = this.props;

    dispatchGetCardWorkDays(employeeCardId, startDate, endDate);
  };

  render() {
    const {
      classes,
      deploymentDetails,
      workScheduleOverrides,
      initializeCreateWorkScheduleOverride,
    } = this.props;

    const dateRanges = workScheduleOverrides.concat(deploymentDetails);

    return (
      <Grid className={classes.root}>
        <CalendarYear
          dateRanges={dateRanges}
          DayComponent={CalendarWorkDay}
          onYearChange={this.getCardWorkDays}
          DateRangeComponent={AvailabilityOverrides}
          onSelectDates={initializeCreateWorkScheduleOverride}
        />
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    marginBottom: theme.spacing(5),
  },
});

EmployeeCalendar.defaultProps = {
  workDays: EMPTY_MAP,
  deploymentDetails: EMPTY_LIST,
  workScheduleOverrides: EMPTY_LIST,
};

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      deploymentDetails: getDeploymentDetailsByCardIdFromState(
        state,
        employeeCardId,
      ),
    }),
    {
      dispatchOnLoad: employeeCalendarOnLoad,
      dispatchGetCardWorkDays: getCardWorkDays,
      dispatchOnUnload: employeeWorkScheduleOverridesOnUnload,
    },
  ),
  withStyles(styles),
)(EmployeeCalendar);
